var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Transition",
    { attrs: { name: _vm.position === "bottom" ? "slide" : "slideinvert" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible || _vm.inline,
              expression: "visible || inline"
            }
          ],
          staticClass: "datetimepicker flex",
          class: {
            inline: _vm.inline,
            "is-dark": _vm.dark,
            visible: _vm.visible
          },
          style: _vm.responsivePosition,
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "datepicker flex flex-direction-column",
              class: { right: _vm.right },
              style: [_vm.responsivePosition, _vm.width]
            },
            [
              !_vm.noHeader
                ? _c("HeaderPicker", {
                    key: _vm.componentKey,
                    attrs: {
                      color: _vm.color,
                      "only-time": _vm.onlyTime,
                      format: _vm.format,
                      "time-format": _vm.timeFormat,
                      "transition-name": _vm.transitionName,
                      "no-time": _vm.onlyDate,
                      dark: _vm.dark,
                      range: _vm.range
                    },
                    model: {
                      value: _vm.value,
                      callback: function($$v) {
                        _vm.value = $$v
                      },
                      expression: "value"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pickers-container flex" },
                [
                  !_vm.onlyTime
                    ? _c("DatePicker", {
                        attrs: {
                          id: _vm.$attrs.id,
                          dark: _vm.dark,
                          month: _vm.month,
                          inline: _vm.inline,
                          "no-weekends-days": _vm.noWeekendsDays,
                          "disabled-weekly": _vm.disabledWeekly,
                          color: _vm.color,
                          "min-date": _vm.minDate,
                          "max-date": _vm.maxDate,
                          "disabled-dates": _vm.disabledDates,
                          "enabled-dates": _vm.enabledDates,
                          range: _vm.range,
                          "no-shortcuts": _vm.noShortcuts,
                          height: _vm.height,
                          "first-day-of-week": _vm.firstDayOfWeek,
                          visible: _vm.visible,
                          "custom-shortcuts": _vm.customShortcuts,
                          "no-keyboard": _vm.noKeyboard,
                          locale: _vm.locale
                        },
                        on: {
                          "change-month": _vm.changeMonth,
                          "change-year-month": _vm.changeYearMonth,
                          close: function($event) {
                            return _vm.$emit("close")
                          }
                        },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.onlyDate
                    ? _c("TimePicker", {
                        ref: "TimePicker",
                        attrs: {
                          dark: _vm.dark,
                          color: _vm.color,
                          inline: _vm.inline,
                          format: _vm.timeFormat,
                          "only-time": _vm.onlyTime,
                          "minute-interval": _vm.minuteInterval,
                          visible: _vm.visible,
                          height: _vm.height,
                          "disabled-hours": _vm.disabledHours,
                          "min-time": _vm.minTime,
                          "max-time": _vm.maxTime,
                          behaviour: _vm.behaviour
                        },
                        model: {
                          value: _vm.time,
                          callback: function($$v) {
                            _vm.time = $$v
                          },
                          expression: "time"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.hasNoButton && !(_vm.inline && _vm.range)
                ? _c("ButtonValidate", {
                    staticClass: "button-validate flex-fixed",
                    attrs: {
                      dark: _vm.dark,
                      "button-color": _vm.buttonColor,
                      "button-now-translation": _vm.buttonNowTranslation,
                      "only-time": _vm.onlyTime,
                      "no-button-now": _vm.noButtonNow,
                      range: _vm.range,
                      "has-button-validate": _vm.hasButtonValidate
                    },
                    on: {
                      validate: function($event) {
                        return _vm.$emit("validate")
                      },
                      now: _vm.setNow
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }